import client from './client';

/* ── All paths are relative to baseURL which is already /api ──
   So: /auth/login  →  https://deltadesk.in/api/auth/login  ✓
   NOT: /api/auth/login → https://deltadesk.in/api/api/auth/login  ✗
─────────────────────────────────────────────────────────────── */
export const authAPI = {
  login: (email, password) =>
    client.post('/auth/login', { email, password }),

  signup: (data) =>
    client.post('/auth/signup', data),

  confirm: (email, code) =>
    client.post('/auth/confirm', { email, code }),

  resendCode: (email) =>
    client.post('/auth/resend-code', { email }),

  me: () =>
    client.get('/auth/me'),
};